/* фикс UTF-8 */


import { armModalOpen } from './modal';
import ArmModalRequest from './modalRequest';

const BX = window.BX;
BX.Vue.use(window['VueModal'].default);

BX.Vue.create({
  name: 'ArmUsedCarsDetail',
  el: '#usedcars-detail',
  data() {
    return {
      carId: 0,
    }
  },
  beforeMount() {
    this.carId = parseInt(this.$el.getAttribute('data-id-car') || 0);

    const vueModalWrap = window.BX.Vue.extend({
      name: 'IsuzuModalWrap',
      components: {
        modalWrap: VueModal.ModalWrap,
      },
      template: '<modal-wrap/>'
    });
  
    const vueModalWrapComponent = new vueModalWrap({ el: document.createElement('div') });
    document.body.appendChild(vueModalWrapComponent.$el);
  },
  mounted() {
    const mySwiperDetail = new Swiper('.mySwiper-detail', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
      slidesPerView: 1,
      centeredSlides: true,
      paginationClickable: true,
      spaceBetween: 10,
      loop: true,
    });

    const mySwiperDetailElement = this.$el.querySelector('.mySwiper-detail');
    mySwiperDetailElement.addEventListener('mouseover', () => {
      mySwiperDetailElement.querySelector('.mySwiper-detail .swiper-button-next').classList.add('active');
      mySwiperDetailElement.querySelector('.mySwiper-detail .swiper-button-prev').classList.add('active');
    });

    mySwiperDetailElement.addEventListener('mouseout', () => {
      mySwiperDetailElement.querySelector('.mySwiper-detail .swiper-button-next').classList.remove('active');
      mySwiperDetailElement.querySelector('.mySwiper-detail .swiper-button-prev').classList.remove('active');
    });

    const linkToggleList = this.$el.querySelectorAll('.desc-accordeon__name, .desc-subaccordeon__name');
    linkToggleList.forEach(linkToggle => {
      linkToggle.addEventListener('click', (event) => {
        event.target.classList.toggle('active');
        const container = event.target.nextElementSibling;
        container.slideToggle(200);
      });
    });

    const mySwiperDetailSlideList = this.$el.querySelectorAll('.mySwiper-detail .swiper-slide');
    mySwiperDetailSlideList.forEach(slide => {
      slide.addEventListener('click', (event) => {
        const slideId = parseInt(event.target.getAttribute('data-id') || 1);
        this.openFullscreenSwiper(mySwiperDetail, slideId);
      });
    });
  },
  methods: {
    openFullscreenSwiper (mySwiperDetail, initialSlideNumber) {
      const mySwiperFullWrap = document.createElement('div');
      mySwiperFullWrap.classList.add('mySwiper-full-wrap');
      
      const mySwiperFullClose = document.createElement('div');
      mySwiperFullClose.classList.add('mySwiper-full-close');

      mySwiperFullWrap.innerHTML = `
        <div class="mySwiper-full">
          <div class="swiper-wrapper"></div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      `;
      
      mySwiperFullWrap.appendChild(mySwiperFullClose);

      document.body.appendChild(mySwiperFullWrap);
      document.body.classList.add('no-scroll');

      const fullscreenSwiper = new Swiper('.mySwiper-full', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
        slidesPerView: 1,
        centeredSlides: true,
        paginationClickable: true,
        spaceBetween: 10,
        loop: true,
      });

      const slideList = mySwiperDetail.slides;
      for (let index = 0; index < slideList.length; index++) {
        fullscreenSwiper.appendSlide(slideList[index].outerHTML);
      }

      fullscreenSwiper.slideTo(initialSlideNumber, 0);

      mySwiperFullClose.addEventListener('click', () => {
        mySwiperFullWrap.remove();
        document.body.classList.remove('no-scroll');
        fullscreenSwiper.destroy();
      });
    },
    toggleBlock (event) {
      event.preventDefault();

      var container = event.target.nextElementSibling;
      if (!container.classList.contains('active')) {
        
        container.classList.add('active');
        container.style.height = 'auto';
  
        var height = container.clientHeight + 'px';
  
        container.style.height = '0px';
  
        setTimeout(function () {
          container.style.height = height;
        }, 0);
        
      } else {
        
        container.style.height = '0px';
  
        container.addEventListener('transitionend', function () {
          container.classList.remove('active');
        }, {
          once: true
        });
        
      }
      
    },
    openRequest (type) {
      armModalOpen({
        title: '',
        component: ArmModalRequest,
        props: {
          carId: this.carId,
          type : type
        }
      });
    },
    contentTooltip() {
      return `
        <div class="contact-more">
          <div class="contact-more__title">
            Узнать
          </div>
          <div class="contact-more__ul">
            <div class="contact-more__li">техническое состояние</div>
            <div class="contact-more__li">состояние лакокрасочного покрытия</div>
            <div class="contact-more__li">индивидуальное коммерческое предложение</div>
          </div>
        </div>
      `;
    }
  }
});